import { Link } from "react-router-dom";
import { CaseCard } from "../components/CaseCard";
import { FrictionFinder } from "../components/FrictionFinder";
import { HeroWorld } from "../components/HeroWorld";
import { ProductDemo } from "../components/ProductDemo";
import { caseStudies, services } from "../content";

export function HomePage() {
  return (
    <main id="main-content" className="home-world">
      <HeroWorld />

      <section className="proof-ribbon" aria-label="Hello Marky product proof">
        <p>Our own product work keeps the agency honest.</p>
        <div>
          <span>Multi-tenant SaaS</span>
          <span>Web, social, and Shopify</span>
          <span>Human handoff</span>
          <span>Observable AI runs</span>
        </div>
      </section>

      <FrictionFinder />

      <section className="selected-work page-section">
        <div className="section-heading section-heading--stack" data-reveal>
          <h2>Work that exists beyond the pitch deck.</h2>
          <p>Hello Marky Chat is our flagship product. Its demos and operating systems show how we think when the work has to survive real use.</p>
        </div>
        <div className="case-grid">
          {caseStudies.map((study, index) => <CaseCard key={study.slug} study={study} index={index} />)}
        </div>
        <Link className="inline-route" to="/work">Explore all product work <span aria-hidden="true">↗</span></Link>
      </section>

      <section className="drift-statement" aria-label="Hello Marky approach">
        <p data-drift-line>Less theatre. More working systems.</p>
        <p data-drift-line>Less chasing. Better handoffs.</p>
        <p data-drift-line>More ambition. More room in the day.</p>
      </section>

      <section className="product-proof page-section">
        <div className="product-proof-copy" data-reveal>
          <p className="section-kicker">Flagship product</p>
          <h2>We build the difficult middle, not only the polished front.</h2>
          <p>Hello Marky Chat connects knowledge, channels, customer context, commerce actions, and people. Try a small part of that flow here.</p>
          <Link className="button button--mint" to="/hello-marky-chat">See the full product story <span aria-hidden="true">↗</span></Link>
        </div>
        <div data-reveal><ProductDemo compact /></div>
      </section>

      <section className="services-preview page-section">
        <div className="services-preview-title" data-reveal>
          <h2>The agency work.</h2>
          <p>Start with the part of the business that keeps returning to your head.</p>
          <Link className="inline-route" to="/services">See how we work <span aria-hidden="true">↗</span></Link>
        </div>
        <div className="service-lines">
          {services.map((service, index) => (
            <article key={service.title} data-reveal>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <div><h3>{service.title}</h3><p>{service.promise}</p></div>
              <i aria-hidden="true">↗</i>
            </article>
          ))}
        </div>
      </section>

      <section className="life-section page-section">
        <div className="life-image life-image--constellation" data-reveal><img src="/visuals/marky-system-constellation.webp" alt="A dimensional constellation of connected tools orbiting Marky" loading="lazy" data-parallax /></div>
        <div className="life-copy" data-reveal>
          <h2>The point is not more technology.</h2>
          <p>The point is a business that answers well, hands work over clearly, and gives the people carrying it some headspace back.</p>
          <Link className="button button--forest" to="/about">Why Hello Marky exists <span aria-hidden="true">↗</span></Link>
        </div>
      </section>

      <section className="closing-cta page-section">
        <img src="/brand/marky-dark.svg" alt="" aria-hidden="true" />
        <h2>Something in the business feels heavier than it should.</h2>
        <p>No polished brief needed. Start with the task, handoff, or customer moment that keeps asking for your attention.</p>
        <Link className="button button--apricot" to="/contact">Tell us what feels heavy <span aria-hidden="true">↗</span></Link>
      </section>
    </main>
  );
}
